import { DOCUMENT } from '@angular/common';
import { computed, inject, Injectable, Renderer2, RendererFactory2, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BREAKPOINT, WINDOW } from '@common';
import { getCssVariable } from '@common/utils';
import { MbsSize } from 'mbs-ui-kit';
import { fromEvent, throttleTime } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BodyStateService {
  private readonly document = inject(DOCUMENT);
  private readonly window = inject(WINDOW);
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private readonly resizeEvent$ = fromEvent(this.window, 'resize').pipe(
    throttleTime(100, undefined, { leading: true, trailing: true }),
    distinctUntilChanged()
  );

  readonly windowWidth = this.createWindowSizeSignal(() => this.window.innerWidth);
  // readonly windowHeight = this.createWindowSizeSignal(() => this.window.innerHeight);

  private createWindowSizeSignal(getter: () => number) {
    return toSignal(this.resizeEvent$.pipe(map(getter)), { initialValue: getter() });
  }

  matchBreakpoint(size: MbsSize, breakpoint?: string): Signal<boolean> {
    return computed(() => this.windowWidth() >= this.getCssVariable(size, breakpoint));
  }

  getCssVariable(size: MbsSize, breakpoint = BREAKPOINT): number {
    return getCssVariable(this.document.documentElement, breakpoint + size);
  }

  setBodyClassState(action: 'add' | 'remove', className: string): void {
    const body = this.document.body;

    if (action === 'remove') {
      this.renderer.removeClass(body, className);
    }

    if (action === 'add') {
      this.renderer.addClass(body, className);
    }

    throw new Error('Unknown action for render body class');
  }
}
